import {SelectElementModelFE} from "../../api/types/generic";

export type ExportFormModel = {
    productCode: SelectElementModelFE | null;
    from: string | null;
    to: string | null;
    dealer: SelectElementModelFE | null
    legalEntity: SelectElementModelFE | null
}

export const initialExportForm: ExportFormModel = {
    productCode: null,
    from: null,
    to: null,
    dealer: null,
    legalEntity: null
}